// extracted by mini-css-extract-plugin
export default {"problem":"problem_problem__eTNJv","solving":"problem_solving__4Uavz"};